import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthScreenComponent} from './components/auth-screen/auth-screen.component';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import AuthRoutingModule from '@app/authorization/auth-routing.module';
import {LoginScreenComponent} from './components/login-screen/login-screen.component';
import {RestoreAccessScreenComponent} from './components/restore-access-screen/restore-access-screen.component';
import {TranslateModule} from '@ngx-translate/core';
import {LogoModule} from "@app/modules/logo/logo.module";
import {LtaBtnModule, LtaInputModule, LtaSelectModule, LtaSvgIconModule} from "@atl/lacerta-ui-common";


@NgModule({
    declarations: [
        AuthScreenComponent,
        LoginScreenComponent,
        RestoreAccessScreenComponent
    ],
    imports: [
        RouterModule,
        AuthRoutingModule,
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        LtaSvgIconModule,
        LogoModule,
        LtaBtnModule,
        LtaInputModule,
        LtaSelectModule
    ]
})
export default class AuthorizationModule {
}
